import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import Grid from "@mui/material/Grid";
import DropDownButton from "../DropDown/DropDownButton";
import Typography from "@mui/material/Typography";
import Profile from "../Modal/Profile";
import { twoDigit } from "../../Js/TimeAndDate";
import { currentAssetSliceActions } from "../../Store/Slices/CurrentAssetSlice";
// import SchoolInfo from "../Modal/SchoolInfo";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import ListItemText from "@mui/material/ListItemText";
import ListItemButton from "@mui/material/ListItemButton";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import MenuBookIcon from "@mui/icons-material/MenuBook";

import Vocabulary from "../../Layouts/Vocabulary";
import MTI from "../../Layouts/Vocabulary/MTI";

import { makeStyles } from "@material-ui/core/styles";
import { useLocation, useNavigate } from "react-router-dom";

var taskDropDownOptions = [
  {
    text: "Assets",
    action: "Redirect",
    path: "/Task/Create",
    pathObj: {
      name: "TaskModule",
    },
    params: {},
  },
  // {
  //   text: "Media",
  //   action: "Redirect",
  //   path: "Task",
  //   pathObj: {
  //     name: "CreateTaskMedia",
  //   },
  //   params: {},
  // },
];

var assignDropDownOptions = [
  {
    text: "Assets",
    action: "Redirect",
    path: "/Assign/Create/assets",
    pathObj: {
      name: "",
      params: {
        type: "assets",
      },
    },
    params: {},
  },
  // {
  //   text: "Media",
  //   action: "Redirect",
  //   path: "Assign",
  //   pathObj: {
  //     name: "CreateAssignment",
  //     params: {
  //       type: "media",
  //     },
  //   },
  //   params: {},
  // },
];

var podcastDropDownOptions = [
  {
    text: "Create Podcast",
    action: "Redirect",
    path: "/Podcast/Create",
    pathObj: {
      name: "PodcastCreate",
    },
    params: {},
  },
  // {
  //   text: "Media",
  //   action: "Redirect",
  //   path: "Task",
  //   pathObj: {
  //     name: "CreateTaskMedia",
  //   },
  //   params: {},
  // },
];

var interval = null;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Header = (props) => {
  const location = useLocation();
  const navigation = useNavigate();
  const classes = useStyles();
  const dispatch = useDispatch();

  const [exHr, setExHr] = useState(0);
  const [exMin, setExMin] = useState(0);
  const [exSec, setExSec] = useState(0);

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // Redux state
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  const siteConfig = useSelector((state) => state.defs.siteConfig);
  const { breadcrumb } = useSelector((state) => state.common);
  const { eexamTime } = useSelector((state) => state.currentAsset);

  useEffect(() => {
    if (location.pathname.split("/").includes("Content") && eexamTime > 0) {
      if (eexamTime && !interval) {
        let curTime = new Date();
        let endTime = new Date(curTime);
        endTime.setMinutes(curTime.getMinutes() + eexamTime / 60);

        // Update the count down every 1 second
        timerCount(curTime, endTime);
        interval = setInterval(() => {
          timerCount(curTime, endTime);
        }, 1000);
      }
    } else {
      clearInterval(interval);
      interval = null;
      setExHr(0);
      setExMin(0);
      setExSec(0);
    }
  }, [location, eexamTime]);

  useEffect(() => {
    if (props.libraryPermission && taskDropDownOptions.length == 1) {
      taskDropDownOptions.push({
        text: "Library",
        action: "Redirect",
        path: "/Task/Create/LibraryTask",
        pathObj: {
          name: "TaskModule",
        },
        params: {},
      });
      assignDropDownOptions.push({
        text: "Library",
        action: "Redirect",
        path: "/Assign/Create/library",
        pathObj: {
          name: "",
          params: {
            type: "library",
          },
        },
        params: {},
      });
    }
  }, [props.libraryPermission]);

  const timerCount = (start, end) => {
    // Get todays date and time
    let now = new Date().getTime();
    // Find the distance between now an the count down date
    let distance = start - now;
    let passTime = end - now;
    if (distance < 0 && passTime < 0) {
      clearInterval(interval);
      // time up
      dispatch(currentAssetSliceActions.setTimeUp(true));
      return;
    } else if (distance < 0 && passTime > 0) {
      calcTime(passTime);
    } else if (distance > 0 && passTime > 0) {
      calcTime(distance);
    }
  };

  const calcTime = (dist) => {
    // console.log("this.statusType",this.statusType);
    // Time calculations for hours, minutes and seconds
    setExHr(Math.floor((dist / (1000 * 60 * 60)) % 24));
    setExMin(Math.floor((dist / (1000 * 60)) % 60));
    setExSec(Math.floor((dist / 1000) % 60));
    /* Time calculations for days, hours, minutes and seconds
    this.days = Math.floor(dist / (1000 * 60 * 60 * 24));
    this.hours = Math.floor((dist % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    this.minutes = Math.floor((dist % (1000 * 60 * 60)) / (1000 * 60));
    this.seconds = Math.floor((dist % (1000 * 60)) / 1000);
    */
  };

  return (
    <Grid container>
      {/* <Grid item xs={12}>
                <Grid container direction="row" justifyContent="flex-end"  alignItems="center" className='pr-1'>
                    <img src='/logo.png' width='45rem'></img>
                </Grid>
            </Grid> */}
      <Grid
        item
        xs={12}
        className=""
        sx={{
          borderBottom: 1,
          borderBottomColor: "#EFEFEF",
          mb: 1,
          pb: 0.5,
        }}
      >
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          className="pl-3"
        >
          <Grid style={{ flex: 1 }}>
            {location.pathname.split("/").includes("Teach") && (
              <DropDownButton text={breadcrumb} hide={true} />
            )}
            {location.pathname.split("/").includes("Assignment") &&
              !location.pathname.split("/").includes("Assignments") && (
                <DropDownButton text={""} hide={true} />
              )}
            {location.pathname.split("/").includes("Task") && (
              <DropDownButton
                title="Create Task"
                options={taskDropDownOptions}
              />
            )}
            {location.pathname.split("/").includes("Library") && (
              <DropDownButton text={""} hide={true} />
            )}
            {location.pathname.split("/").includes("Assign") &&
              userInfo.rolesInfo.title.toLowerCase() == "trainer" && (
                <DropDownButton
                  title="Create Assignment"
                  options={assignDropDownOptions}
                />
              )}
            {location.pathname.split("/").includes("Profile") && (
              <DropDownButton hide={true} />
            )}
            {location.pathname.split("/").includes("Vocabulary") && (
              <DropDownButton hide={true} />
            )}
            {location.pathname.split("/").includes("CourseConfig") && (
              <DropDownButton hide={true} />
            )}

            {location.pathname.split("/").includes("LicenseInfo") && (
              <DropDownButton hide={true} />
            )}

            {location.pathname.includes("Users") && (
              <DropDownButton text={""} hide={true} />
            )}

            {location.pathname.split("/").includes("Report") && (
              <DropDownButton text={""} hide={true} />
            )}

            {location.pathname.split("/").includes("Assess") && (
              <DropDownButton text={""} hide={true} />
            )}

            {location.pathname.split("/").includes("Podcast") &&
              userInfo.rolesInfo.title.toLowerCase() == "broadcast" && (
                <DropDownButton
                  title="Create"
                  options={podcastDropDownOptions}
                />
              )}
          </Grid>

          <Grid className="pr-1">
            <Grid container direction="row" alignItems="center">
              {location.pathname.split("/").includes("Content") &&
                eexamTime > 0 && (
                  <Typography
                    color="primary.main"
                    sx={{
                      fontWeight: "600",
                      fontSize: "1.4rem",
                      "@media (min-width: 1636px)": {
                        fontSize: "1.5rem",
                      },
                    }}
                    component={"span"}
                  >
                    {`${twoDigit(exHr)}:${twoDigit(exMin)}:${twoDigit(exSec)}`}
                  </Typography>
                )}
              <Grid>
                {/* <MTI></MTI> */}
                <React.Fragment>
                  <IconButton
                    color="primary"
                    aria-label="Open vocabulary"
                    onClick={handleClickOpen}
                  >
                    <MenuBookIcon sx={{ fontSize: "1.8rem" }} />
                  </IconButton>
                  <Dialog
                    fullScreen
                    open={open}
                    onClose={handleClose}
                    TransitionComponent={Transition}
                  >
                    <AppBar sx={{ position: "relative" }}>
                      <Toolbar>
                        <IconButton
                          edge="start"
                          color="inherit"
                          onClick={handleClose}
                          aria-label="close"
                        >
                          <CloseIcon />
                        </IconButton>
                        <Typography
                          sx={{ ml: 2, flex: 1 }}
                          variant="h6"
                          component="div"
                        >
                          Vocabulary
                        </Typography>
                      </Toolbar>
                    </AppBar>
                    <Vocabulary></Vocabulary>
                  </Dialog>
                </React.Fragment>
              </Grid>
              <Grid>
                {!location.pathname.includes("Profile") && <Profile />}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
const useStyles = makeStyles({});
export default Header;
